export default "# Property Records\n\nThis information is derived from a variety of public and private sources.";